<template>
<div>
    <h4>{{ group }}</h4>
    <h5>Risks <b-badge variant="primary">{{ items.length }}</b-badge></h5>
    <ul>
        <li v-for="item in items">
            {{ item.title }} <span v-for="q in item.questionnaires" class="numbering">{{ q.name }}</span>
            <b-btn size="sm" style="margin-bottom: 5px" @click.prevent="$emit('edit_click', item)">Edit</b-btn>
        </li>
    </ul>
    <b-btn @click.prevent="detail_btn_click">More</b-btn>
    <b-btn style="margin-left: 10px" variant="primary" @click.prevent="add_btn_click">Add</b-btn>
</div>
</template>


<script>
export default {
  data () {
    return {
    }
  },
  name: 'TurtleItem',
  props: ['items', 'group'],
  created () {
  },
  watch: {
      
  },
  methods: {
      add_btn_click() {
          this.$emit('add_btn_click')
      },
      detail_btn_click() {
          this.$emit('detail_btn_click')
      }
  },
  components: {
  }
}
</script>
<style>

.numbering + .numbering:before {
    content: ", ";
}
</style>
